import React from 'react';
import PropTypes from 'prop-types';
import Canvas from "./Canvas";
import {TOP_VIEW_IMAGE_INDEX, IZO_TRANSFORM_A, IZO_TRANSFORM_B, IZO_TRANSFORM_C, IZO_TRANSFORM_D} from "../../utils/Constant";
import * as HelperCanvas from '../../utils/HelperCanvas';

class Equipment extends Canvas {

  constructor(props) {
    super(props);

    this.state = {
      thumb: null,
      images: [],
      limitColor: 'transparent'
    }
  }

  componentDidMount() {

    this.ctx = this.refs.equipment.getContext('2d');
    this.ctx.imageSmoothingQuality = 'high';
    this.props.setCtx(this.props.zIndex, this.ctx);

    if (this.props.data.images) {

      Promise.all(this.props.data.images.map((src, index) => this.loadImage(src, index))).then(() => {
        /*this.setState({
          images : [...this.state.images, this.props.webp],
        })*/
        this.draw();
      });
    }
  }

  componentDidUpdate() {
    this.draw();
  }

  loadImage = (src, index) => new Promise(resolve => {

    if (src) {

      let img = new Image();
      let images = this.state.images;

      img.src = src;
      img.onload = () => resolve({img, isLoaded: true});
      img.onerror = () => resolve({src, isLoaded: false});

      images[index] = img;

      this.setState({
        images
      });
    }

  });

  getActiveImgIndex = () => {
    return this.props.data.activeImgIndex || 0;
  };

  //todo:: вынести загрузку изображений в родительский компонент
  draw = (limitColor = this.props.data.limitColor) => {

    this.clear(true);
    this.ctx.save();

    let {x, y} = this.props.data.position; //прилетают огромными числами (т.е. разделенными на scale)

    const isTopView = this.props.viewTop;

    const idx = this.getActiveImgIndex();
    const image = this.state.images[idx];

    const offset = this.props.data.origins?.[idx] ? this.props.data.origins[idx] : {x: 0, y: 0}


    const {scale} = this.props.sizes;


    try {

      if (image && this.ctx instanceof CanvasRenderingContext2D && image instanceof HTMLImageElement) {

        if (isTopView) {

          let imageTop = this.state.images[TOP_VIEW_IMAGE_INDEX];

          if (imageTop && imageTop instanceof HTMLImageElement) {

            let angle = this.getActiveImgIndex() * 45;
            let baseX = this.props.sizes.position.x / scale; //(чтобы в одной размерности с Х) делим на масштаб
            let baseY = this.props.sizes.position.y / scale;

            // let imageCenterX = image.width / 2;
            // let imageCenterY = image.height / 2;
            let imageTopCenterX = imageTop.width / 2;
            let imageTopCenterY = imageTop.height / 2;

            //Далее рисуем границы:
            // const padding = 0;

            this.ctx.save();

            //Крутим-вертим канвас
            this.prepareViewTopCanvas(x, y, baseX, baseY, imageTopCenterX, imageTopCenterY, angle, scale);

            //Общее масштабирование строго после вращений (масштабирование - ради самой картинки оборудования)
            this.ctx.scale(scale, scale);

            this.drawSelection(this.props.data.coordinates, limitColor === 'green', imageTop.width, imageTop.height);
            //Рисуем, корректируя на размер картинки (мы в центре, нужны к-ты под левый верхний угол)
            this.ctx.drawImage(imageTop, -imageTopCenterX, -imageTopCenterY);

            // set the composite operation
            /*this.ctx.globalCompositeOperation='color';
            this.ctx.fillStyle = "white";
            this.ctx.globalAlpha = 1;  // alpha 0 = no effect 1 = full effect
            this.ctx.fillRect(0, 0, imageTop.width, imageTop.height);*/

            //временные рисовалки-проверки3
//            this.checkCorrectBackTransform3(x, y, baseX, baseY, scale, image);

            this.ctx.restore();
          }
        } else {
          /*this.ctx.shadowColor = '#5FEC4F';
          this.ctx.shadowBlur = 3;
          this.ctx.shadowOffsetX = 0;
          this.ctx.shadowOffsetY = 0;
          this.ctx.drawImage(image, x, y);

          // get contents of blurry bordered image #5FEC4F
          const imgData = this.ctx.getImageData(
            0,
            0,
            this.ctx.canvas.width - 1,
            this.ctx.canvas.height - 1
          );

          const opaqueAlpha = 255;
          const t = 3;

          // turn all non-transparent pixels to full opacity
          for (let i = imgData.data.length; i > 0; i -= 4) {
            if (imgData.data[i + t] > 0) {
              imgData.data[i + t] = opaqueAlpha;
            }
          }

          // write transformed opaque pixels back to image
          this.ctx.putImageData(imgData, 0, 0);

          this.ctx.shadowColor = 'rgba(0, 0, 0, 0)';
          this.ctx.shadowBlur = 3;
          this.ctx.shadowOffsetX = 0;
          this.ctx.shadowOffsetY = 0;
          this.ctx.drawImage(image, x, y);*/

          if(limitColor !== 'transparent') {
            this.ctx.shadowColor = 'rgba(0, 0, 0, .95)';
            this.ctx.shadowBlur = 12;
            this.ctx.shadowOffsetX = 0;
            this.ctx.shadowOffsetY =   0;

          }

          if(limitColor === 'yellow') {
            y -= 12
            this.ctx.shadowOffsetY = 12;
          }

          this.ctx.scale(scale, scale);
          this.ctx.drawImage(image, x + offset.x, y + offset.y);


          /////////////////////////////////
          /*let imageData = this.ctx.getImageData(0,0,image.width, image.height);

          /!*const pixels = imageData.data;

          for (let i = 3, n = this.ctx.width * this.ctx.height * 4; i < n; i += 4) {
            pixels[i] = pixels[i] < 127? 0 : 255
          }
          this.ctx.putImageData(imageData, 0, 0);*!/


          /!*var textString = `Z-index: ${this.props.zIndex}`,
            textWidth = this.ctx.measureText(textString ).width;
          this.ctx.fillText(textString , x, y);*!/

          imageData = new Border(imageData);
          this.ctx.drawImage(imageData, 0, 0);
          */

          /*var textString = `Z-index: ${this.props.zIndex}`,
            textWidth = this.ctx.measureText(textString ).width;
          this.ctx.fillText(textString , x, y);*/
          const color = this.props.showContour ? 'red' : 'transparent';
          this.drawLimits(color);


        }
      }

    } catch (e) {
      console.log(image);
      console.log(e);
    }

  };

  //Подготовка канваса к рисованию картинки viewTop
   prepareViewTopCanvas(x, y, baseX, baseY, correctX, correctY, angle, scale) {
      //смещение по x и y в изометрической картинке от левого верхнего угла изометрической площадки:
      let shiftIzoX = x - baseX;
      let shiftIzoY = y - baseY;

      //Поскольку картинки изо и topView могут отличаться своим масштабом, работаем по их серединам ширины и высоты.
      shiftIzoX += correctX; //imageCenterX;  //68
      shiftIzoY += correctY; //imageCenterY;

      //На viewTop площадке смещение начинаем собирать от нуля экрана:
      let shiftX = 0;
      let shiftY = 0;

      let a = IZO_TRANSFORM_A;  //scale по горизонтали
      let b = IZO_TRANSFORM_B;  //на N пикселей вниз
      let c = IZO_TRANSFORM_C;   //каждая следующая строчка будет смещена на N пиксель вправо, относительно предыдущей.
      let d = IZO_TRANSFORM_D; //scale по вертикали

      //ищем координаты смещения с пом. обратного изо-преобразования:
      let shiftBackXY = HelperCanvas.calculateBackTransform(shiftIzoX, shiftIzoY, a, b, c, d, scale);

      // Добавляем это базовое смещение к topView картинке относительно левого верхнего угла TopView площадки:
      shiftX += shiftBackXY.x;
      shiftY += shiftBackXY.y;

      //Вариант 1
      //временные рисовалки-проверки (до главного backTransformWithFlipAndRotate):
//      this.checkCorrectBackTransform1(x, y, baseX, baseY, shiftBackXY, a, b, c, d, scale);

      // //главный метод обратной трансформации (такой же как для самой площадки):
      // //(Смещение shiftХ,shiftY повернуто на 90 град!)
      // this.backTransformWithFlipAndRotate((baseX + shiftY) * scale, (baseY + shiftX) * scale, scale);

      //временные рисовалки-проверки (после главного backTransformWithFlipAndRotate):
//      this.checkCorrectBackTransform2(x, y, baseX, baseY, shiftBackXY, a, b, c, d, scale);

    //   //и крутим канвас (оборудование) на пользовательский угол:
    // // angle += 270; //-90 потому, что изо площадка так хитро повернута
    //   this.ctx.rotate(Math.PI * angle/180);

      //вариант 2, без зеркалирования, иначе картинка оборудования тоже зеркалится:
      shiftX -= 55; //нужно дополнительно подкорректировать на {x: 30, y: -55};
      shiftY += 30; //но помним что shiftX и shiftY поменяны местами

      this.ctx.translate((baseX + shiftY) * scale, (baseY + shiftX) * scale);

      this.ctx.rotate(-Math.PI * (angle + 90) / 180);
  }

  isHit = (x, y) => {
    return this.ctx.isPointInPath(x, y);
  };


  handlerRightBthClick = (e) => {
    e.preventDefault();
  };

  /**
   *
   * @param color
   * @param lineWidth
   * @param demx
   * @param demy
   * @param limits
   */
  drawLimits = (color = 'transparent', lineWidth = 3, demx = this.props.data.position.x, demy = this.props.data.position.y, limits) => {

    let coordinates = [];

    if (limits) {
        coordinates = limits;
    } else {

      if (true) { //!this.props.viewTop
        let index = this.getActiveImgIndex();

        if (this.props.data.coordinates && this.props.data.coordinates[index]) {
          coordinates = this.props.data.coordinates[index];
        }
      }
    }

    if (coordinates && coordinates.length) { //сразу отсечем и не будем входить
      //this.ctx.translate(demx,demy);

      this.ctx.beginPath();
      this.ctx.strokeStyle = color;
      this.ctx.lineWidth = lineWidth;

      this.ctx.moveTo(coordinates[0].x * 1 + demx, coordinates[0].y * 1 + demy);

      let i;

      for (i = 1; i < coordinates.length; i++) {
        this.ctx.lineTo(coordinates[i].x * 1 + demx, coordinates[i].y * 1 + demy);
      }
      this.ctx.lineTo(coordinates[0].x * 1 + demx, coordinates[0].y * 1 + demy);

      this.ctx.stroke();
      this.ctx.closePath();
    }

  };

  drawSelection(coordinates, isSelected, width, height) {
    const padding = 0;
    let limits = [
      {x:       - padding, y:        - padding},
      {x: width + padding, y:        - padding},
      {x: width + padding, y: height + padding},
      {x:       - padding, y: height + padding}
    ];
    const coord = coordinates[8]? coordinates[8] : limits;

    this.ctx.translate(-width / 2, -height / 2);
    this.ctx.beginPath();
    this.ctx.fillStyle = isSelected ? 'rgba(0,100,0,0.2)' : 'transparent';
    this.ctx.moveTo(coord[0].x * 1, coord[0].y * 1);
    let i;
    for (i = 1; i < coord.length; i++) {
      this.ctx.lineTo(coord[i].x * 1, coord[i].y * 1);
    }
    this.ctx.lineTo(coord[0].x * 1, coord[0].y * 1);

    this.ctx.fill();
    this.ctx.closePath();
    this.ctx.translate(width / 2, height / 2);
  }

  render() {
    return <canvas
      id={`equipment_${this.props.data.id}`}
      className={this.props.className}
      width={this.props.sizes.width} height={this.props.sizes.height}
      ref="equipment" onContextMenu={this.handlerRightBthClick}
    />
  }

}

Equipment.propTypes = {
  setCtx: PropTypes.func.isRequired,
  position: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  zIndex: PropTypes.number.isRequired,
};

export default Equipment;
